module.exports = __webpack_public_path__ + "static/media/ruleImg.0e7797f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ruleImg.png
// module id = 1851
// module chunks = 0 1